// @ts-nocheck

import React, { useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';
import styled, { css, keyframes } from 'styled-components';

import { Target } from '../../client';
import { ZIndices } from '../../styled-components/dark/common';

const appearAnim = keyframes`
  0% {
    opacity: 0;
    transform: translate(-50%, -30%);
    pointer-events: none;
  }
  100% {
    opacity: 1;
    pointer-events: auto;
  }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 50vh;
  left: 50vw;
  max-width: 25em;
  transform: translate(-50%, -50%);

  border-radius: 0.4em;
  padding: 2em;
  color: white;
  background: #111111;
  z-index: ${ZIndices.modal + 1};
  transition: filter 200ms ease-in-out;
  box-shadow: 0px 0px 10px black;

  ${!Target.__MOBILE__
    ? css`
        &:hover {
          filter: brightness(1.2);
        }
      `
    : css`
        width: 80vw;
      `}

  &.opt-in-error-modal-transitions-enter {
    animation: ${appearAnim} 300ms ease-out forwards;
  }

  &.opt-in-error-modal-transitions-exit {
    animation: ${appearAnim} 300ms ease-out forwards reverse;
  }

  ${({ $clickable }) =>
    $clickable
      ? css`
          cursor: pointer;
        `
      : null};
`;

type OptInErrorModalProps = {
  className?: string;
  children: React.ReactNode;
  onClose: () => void;
  isOpened: boolean;
};

const SimpleInfosModal = ({ children, className = '', onClose, isOpened }: OptInErrorModalProps) => {
  const onClick = useCallback(
    (e) => {
      e.stopPropagation();
      onClose();
    },
    [onClose],
  );

  return (
    <CSSTransition classNames="opt-in-error-modal-transitions" in={isOpened} timeout={300} mountOnEnter unmountOnExit>
      <Wrapper className={`${className} modal-clickable-elements`} onClick={onClick} $clickable={!!onClose}>
        {children}
      </Wrapper>
    </CSSTransition>
  );
};

export default SimpleInfosModal;
